export var ActionOperationMethod;
(function (ActionOperationMethod) {
    ActionOperationMethod["SetState"] = "SET_STATE";
    ActionOperationMethod["RemoveState"] = "REMOVE_STATE";
    ActionOperationMethod["ClearStates"] = "CLEAR_STATES";
    ActionOperationMethod["OpenUrl"] = "OPEN_URL";
})(ActionOperationMethod || (ActionOperationMethod = {}));
export var ActionTrigger;
(function (ActionTrigger) {
    ActionTrigger["Click"] = "click";
    ActionTrigger["MouseDown"] = "mousedown";
    ActionTrigger["MouseUp"] = "mouseup";
    ActionTrigger["MouseEnter"] = "mouseenter";
    ActionTrigger["MouseLeave"] = "mouseleave";
    ActionTrigger["TouchStart"] = "touchstart";
    ActionTrigger["TouchEnd"] = "touchend";
    // TouchMove = 'touchmove',
    ActionTrigger["TouchCancel"] = "touchcancel";
})(ActionTrigger || (ActionTrigger = {}));
